var map = {
	"./bash": 1815,
	"./java": 1816,
	"./json": 1817,
	"./julia": 1818,
	"./python": 1819,
	"./r": 1820,
	"./rust": 1821,
	"./scala": 1822,
	"./shell": 1823,
	"./sql": 1824,
	"./xml": 1825,
	"./yaml": 1826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1814;